//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getData } from './data';
import show from '@/components/diff/show.vue';
export default {
  components: { show },
  data() {
    return {
      loading: false,
      treeData: {
        config: [],
        perm: [],
      },
    };
  },
  created() {
    const { env, tag, appid } = this.$route.query;
    if ([env, tag, appid].includes(undefined)) {
      this.$router.replace({
        name: 'version-manage',
      });
      return;
    }
    this.getDetail(env, tag, appid);
  },
  methods: {
    async getDetail(env, tag) {
      this.loading = true;
      try {
        const res = await this.$request({
          url: this.$api.getAuthByTag,
          data: { env, tag },
        });
        console.log('接口数据:', res);
        this.treeData = getData(res);
        console.log('detail:', this.treeData);
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
  },
};
